<template>
  <div class="build">
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px 40px' }" class="hidden-xs-only">
      <div class="title">· 党建专栏 ·</div>
      <div class="build-array">
        <div class="build-content" v-for="(item, index) in buildArr" :key="index" @click="onBuild(index)">
          <div class="build-title">
            {{ item.title }}
          </div>
          <div class="build-desc">
            {{ item.desc }}
          </div>
          <div class="time">
            {{ item.time }}
          </div>
        </div>
      </div>
    </el-card>
    <el-card shadow="always" :body-style="{ padding: '20px' }" class="hidden-sm-and-up">
      <div class="title">· 党建专栏 ·</div>
      <div class="build-array">
        <div class="build-content" v-for="(item, index) in buildArr" :key="index" @click="onBuild(index)">
          <div class="build-mobil-title">
            {{ item.title }}
          </div>
          <div class="build-mobil-desc">
            {{ item.desc }}
          </div>
          <div class="time">
            {{ item.time }}
          </div>
        </div>
      </div>
    </el-card>
    <br class="hidden-xs-only">
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
import { buildArr } from './data/data'
export default {
  name: 'BuildIndex',
  data() {
    return {
      buildArr: buildArr
    }
  },
  methods: {
    onBuild(index) {
      this.$router.push({ name: `Build${this.buildArr.length - 1 - index}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  color: #f7221d;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #F5DC2A;
  height: 28px;
  width: 450px;
  margin: 0 auto;
}

.build-content {
  height: 128px;
  padding: 50px 60px;
  border-bottom: 2px solid rgb(242, 241, 241);
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  .build-title {
    border-left: 5px solid #f7221d;
    text-indent: 1em;
    font-size: 20px;
    font-weight: 700;
    margin-left: -24px;
    margin-bottom: 16px;

    &:hover {
      color: #f7221d;
    }
  }

  .build-desc {
    height: 80px;
    font-size: 14px;
    color: #888;
    text-align: justify;
    line-height: 20px;
  }

  .time {
    text-align: right;
    font-size: 14px;
    color: #888;
    margin-top: 10px;
  }
}

@media screen and(max-width: 768px) {
  .title {
    width: 100%;
  }

  .kongxi {
    height: 10px;
  }

  .build-content {
    padding: 0;
    height: unset;

    .build-mobil-title {
      font-size: 22px;
      font-weight: 700;
      margin-top: 10px;
    }

    .build-mobil-desc {
      font-size: 16px;
      color: #888;
      margin: 10px 0;
    }

    .time {
      font-size: 14px;
      color: #888;
      text-align: right;
      margin-bottom: 20px;
    }
  }
}
</style>
